import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import useGPICouponPatientPay from "./hooks/useGPICouponPatientPay";

const GPICouponPatientPay = () => {
  const gpiCouponPatientPayData = useGPICouponPatientPay();

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={gpiCouponPatientPayData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {gpiCouponPatientPayData.screen_title} -{" "}
          <span className="heading-cod">{gpiCouponPatientPayData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={gpiCouponPatientPayData.formFields}
        dropdownValues={gpiCouponPatientPayData.dropdownValues}
        paramsData={gpiCouponPatientPayData.paramsData}
        updataParamData={gpiCouponPatientPayData.updateParamData}
      />
      <ButtonsSection ctaButtons={gpiCouponPatientPayData.ctaButtons} />
      <DisplayTable
        data={gpiCouponPatientPayData.data}
        parmKey={gpiCouponPatientPayData.parmKey}
        menuOptions={gpiCouponPatientPayData.menuOptions}
        tableHeaders={gpiCouponPatientPayData.columnDef}
        setRowData={gpiCouponPatientPayData.setRowData}
        selectedPriceSchedules={gpiCouponPatientPayData.selectedRows}
        setSelectedPriceSchedules={gpiCouponPatientPayData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={gpiCouponPatientPayData.first}
          rows={gpiCouponPatientPayData.rows}
          totalRecords={gpiCouponPatientPayData.totalRecords}
          currentPage={gpiCouponPatientPayData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={gpiCouponPatientPayData.onPageChange}
        />
      </div>
      {gpiCouponPatientPayData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={gpiCouponPatientPayData.isConfirmationModalOpen}
          onRequestClose={gpiCouponPatientPayData.closeConfirmationModal}
          onBack={gpiCouponPatientPayData.closeConfirmationModal}
          onSave={gpiCouponPatientPayData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={gpiCouponPatientPayData.setSelectedOption}
        />
      )}
      {gpiCouponPatientPayData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={
            gpiCouponPatientPayData.isInactiveConfirmationModalOpen
          }
          onRequestClose={
            gpiCouponPatientPayData.closeInactiveConfirmationModal
          }
          onBack={
            gpiCouponPatientPayData.closeInactiveConfirmationModal
          }
          onSave={
            gpiCouponPatientPayData.inactivateRecord
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            gpiCouponPatientPayData.setInactiveSelectedOption
          }
        />
      )}
    </div>
  );
};

export default GPICouponPatientPay;  
